import type { CSSProperties } from 'react';

import classes from './StatusChips.module.css';
import tableClasses from 'Components/UI_Library/TableElements/Table.module.css';

export const listStatus = {
    SCHEDULED: 'Scheduled',
    'IN FLIGHT': 'In flight',
    READY: 'Processing',
    PROCESSING: 'Processing',
    Processing: 'Processing', // Status for when mAccount funds have ran out
    UPLOADED: 'Processing',
    FAILED: 'Failed',
    'PARTIAL FAILURE': 'Partial failure',
    'NEEDS APPROVAL': 'Needs approval',
    'AWAITING FUNDS': 'Awaiting funds',
    'AWAITING PAYMENT': 'Awaiting payment',
    'PAYMENT PROCESSING': 'Payment processing',
    REJECTED: 'System declined',
    DRAFT: 'Draft',
    PENDING: 'Pending',
    APPROVED: 'Approved',
    ONBOARDING: 'Onboarding',
    'APPROVED - CARDS ONLY': 'Approved - Cards only',
    'APPROVED - NO KYC': 'Approved - Referral only',
    'CARDS ONLY': 'Cards only',
    'REFERRAL ONLY': 'Referral only',
    PROCESSED: 'Done',
    DONE: 'Done',
    PAID: 'Paid',
    'OCR IN PROGRESS': 'Ocr in progress',
    TERMINATED: 'User declined',
    'PAID EXTERNALLY': 'Paid externally',
    SUBMITTED: 'Submitted',
    SENT: 'Sent',
    SENDING: 'Sending',
    ERROR: 'ERROR',
    CONNECTED: 'Connected',
    'MIN REPAYMENT DUE': 'Min repayment due',
    'AVAILABLE BALANCE': 'Available balance',
    'OUTSTANDING BALANCE': 'Outstanding balance',
    Cardholder: 'Cardholder',
    Manager: 'Manager',
    Approver: 'Approver',
    Creator: 'Creator',
    Custom: 'Custom',
    Owner: 'Owner',
    Viewer: 'Viewer',
    IDVERIFIED: 'ID VERIFIED',
    'SUPPORT VIEW ONLY': 'SUPPORT VIEW ONLY',

    // Subscriptions
    active: 'ACTIVE',
    in_trial: 'In trial',
    trial_expired: 'Trial expired',
    suspended: 'Suspended',
    cancelled: 'Cancelled',
    pending: 'Pending',

    // Approvals
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected',
    'Not required': 'Not required',

    // Beneficiary matching
    PERFECT_MATCH: 'Perfect match',
    STRONG_MATCH: 'Strong match',
    WEAK_MATCH: 'Weak match',
    // Xero import statuses
    COMPLETE: 'Complete',
    'IN PROGRESS': 'In progress',

    // Duplicate payments
    HIGH_CONCERN: 'HIGH CONCERN',
    LOW_CONCERN: 'LOW CONCERN',

    // Misc
    ACTIVE: 'Active',
    ARCHIVED: 'Archived',
    LOCKED: 'Locked',
    'MANAGE-LOCKED': 'Locked',
    'PAYTRON-LOCKED': 'Locked',
    WAITLIST: 'Waitlist',

    // GPS cards
    'Card spend': 'Card spend',
    CANCELLED: 'Cancelled',

    // Budget transactions
    'Bill payment': 'Bill payment',
    Payment: 'Payment',
    NEW: 'New',
    DELETED: 'DELETED',
    /** ??? */
    DONE_SCHEDULED: 'Done',
};

export type Status = keyof typeof listStatus;

const StatusChip = (props: {
    status: Status | undefined; // INSPECT: not sure whether it's intentional to have undefined here, but there are a few places in codebase that passes undefined (according to TS)
    filled?: boolean;
    inTable?: boolean;
    className?: string;
    style?: CSSProperties;
}) => {
    const formattedClassName = () => {
        let className = classes.statusChip;
        if (props.status)
            className = `${className} ${
                classes[listStatus[props?.status]?.replaceAll(/[^a-zA-Z]+/g, '')?.toLowerCase() as keyof typeof classes] // FIXME: should sort out the type assertion
            }`;
        if (props.filled) className = `${className} ${classes.filled}`;
        if (props.inTable) className = `${className} ${tableClasses.regularText}`;
        if (props.className) className = `${className} ${props.className}`;
        return className;
    };

    return (
        <div className={formattedClassName()} style={props.style}>
            {props.status && listStatus[props.status]}
        </div>
    );
};

export default StatusChip;
